import { concat } from 'lodash';
import React, { FC } from 'react';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import PruefAssistenz from '../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const DeMinimisGlobal: FC<{}> = () => {
	return (
		<>
			<ApplicationHeading title='De-minimis-Selbsterklärung' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={P.Deminimis_Pruefung_Pruefstatus.path}
				hinweisPath={P.Deminimis_Pruefung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Deminimis_Pruefung_Ueberarbeitet_Am.path}
				erledigtPath={P.Deminimis_Pruefung_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
		</>
	);
};

export default DeMinimisGlobal;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Deminimis_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};

export const getFormStrucMinimisPruefAssistenz = (application: any) => {
	if (checkIfPruefAssitenzNeedsToValidate(application, P.Deminimis_Pruefung_Pruefstatus.path, P.Deminimis_Pruefung_Erledigt.path)) {
		return concat(formStrucPruefAssistenz());
	} else {
		return [];
	}
};
